<template>
    <v-container class="d-flex flex-column pa-0 ml-3">

          <v-btn :to="{name: 'raporty.godziny' }" x-large :color="$route.name === 'raporty.godziny' ? selectedColor : defaultColor"  width="250" active-class="aa" exact>
            Godziny wg cennika  
            </v-btn>

             <v-btn :to="{name: 'raporty.naleznosci' }" x-large :color="$route.name === 'raporty.naleznosci' ? selectedColor : defaultColor"  width="250" active-class="aa" exact>
            Należności wg grupy  
            </v-btn>

    </v-container>
</template>

<script>
export default {
    data(){
        return{
            defaultColor:'secondary', 
            selectedColor:'primary'
        }
    },
    mounted(){
    
      //this.$store.dispatch( 'loadLookups' );
    },
    computed:{
      user(){
        return this.$store.getters.getUser;
      },
    },
}
</script>

<style scoped>
.v-btn{
  margin-bottom: 1em;
}
.v-chip{
  margin-left: 1em;
}
.v-chip:hover{
    cursor: pointer;
}

.v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
    opacity: 0;
}

</style>